import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useIsEmployeeOnly } from "../hooks/useIsAdmin";

/**
 * Route guard for the Overview dashboard and its print view. An
 * employee-only user reads just their own and on-behalf suggestions
 * (backend read scope, 2026-09-29), so the scheme-wide dashboard is not
 * theirs to open — they land on their Suggestions list instead. Sits
 * inside `RequireAuth`, like `RequireAdmin`.
 */
export default function RequireOverviewAccess({
  children,
}: {
  children: ReactNode;
}) {
  const { isEmployeeOnly, isLoading } = useIsEmployeeOnly();

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (isEmployeeOnly) return <Navigate to="/suggestions" replace />;

  return <>{children}</>;
}
